import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) { navigate("/console/login"); return; }
    axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((r) => { setUser(r.data); navigate("/console", { state: { user: r.data } }); })
      .catch((e) => setError(e.response?.data?.detail || "Sign-in failed."));
  }, [navigate, setUser]);

  if (error) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="text-center max-w-sm">
        <p data-testid="auth-callback-error" className="text-sm text-red-600 bg-red-50 border border-red-200 p-4">{error}</p>
        <button onClick={() => navigate("/console/login")} className="text-xs text-slate-500 underline mt-4">Back to login</button>
      </div>
    </div>
  );
  return <div className="min-h-screen flex items-center justify-center bg-slate-50 text-sm text-slate-400">Signing you in…</div>;
}
